import { render, staticRenderFns } from "./PlacasPreventivas.vue?vue&type=template&id=6b9433be&scoped=true&"
import script from "./PlacasPreventivas.vue?vue&type=script&lang=js&"
export * from "./PlacasPreventivas.vue?vue&type=script&lang=js&"
import style0 from "./PlacasPreventivas.vue?vue&type=style&index=0&id=6b9433be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9433be",
  null
  
)

export default component.exports